import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrderFormRoutingModule } from './order-form-routing.module';
import { OrderFormComponent } from './order-form.component';

@NgModule({
  declarations: [OrderFormComponent],
  imports: [
    OrderFormRoutingModule,
    SharedModule.forRoot(),
  ],
  exports: [
    OrderFormComponent
  ],
  providers: [],
})
export class OrderFormModule { }
